module.exports = msx["rootInjector"];